<script>
import { required } from 'vuelidate/lib/validators'

import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Risks from './risks'

import axios from 'axios'

export default {
  page: {
    title: 'Entra ID Risks',
    meta: [{ name: 'description', content: appConfig.description }]
  },
	components: { Layout, PageHeader, Risks },
  data () {
    return {
      title: 'Entra ID Risks',
      category: 'List',
      items: [
        {
          text: 'Home',
          href: '/'
        },
        {
          text: 'All Risks',
          active: true
        }
      ]
    }
  },
  validations: {
    event: {
      title: { required },
      category: { required }
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {

  }
}
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
		<div class="row">
			<div class="col-12">
				<div class="card">
					<div class="card-body">
						<Risks :url="'/entra_id/risks/list?'" />
					</div>
				</div>
			</div>
		</div>
	</Layout>
</template>
